// @ts-strict-ignore
import React, { useEffect } from "react";

// eslint-disable-next-line local-eslint-rules/enforce-namespace-modularity
import { useConfirmationModal } from "@services/useConfirmationModal";

export const ConfirmImpersonationFetch = ({ resolve, url }: { resolve: (result) => void; url: string }) => {
  const confirm = useConfirmationModal();

  useEffect(() => {
    confirm(
      <>
        Be careful as some changes <b>cannot</b> be undone. Are you sure you want to make this change?
        <br />
        <br />
        <i>(endpoint URL: {url})</i>
      </>,
      {
        intent: "warning",
        heading: "You are making a change in a customer dashboard",
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      }
    );
  }, [confirm, resolve, url]);
  return null;
};
